// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QiCeV2LjRI8doElB8RFM{flex-grow:1;margin-left:16px;display:flex;position:relative}.CN3qJNtC5bAz9NqbiY2z{flex-direction:column;width:100%;min-width:0;padding:10px 0;display:flex}.Nhhb57aUMwkTOHZqrOIh{margin-bottom:4px}.fBioiwZ1VdoHytqqPnQh{width:100%;min-width:0;line-height:16px}.gAMasWbIqEivzAoEhvy0{width:100%;min-width:0;display:flex}.Thy9qDxrtncXjt4yYb_D{flex:1;min-width:0;overflow:hidden}.Thy9qDxrtncXjt4yYb_D>span{width:100%;display:block}.zWWW2FVECQ6mGLLwLN2Y{background:var(--black-10);border-radius:6px;padding:4px 8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `QiCeV2LjRI8doElB8RFM`,
	"messageWrap": `CN3qJNtC5bAz9NqbiY2z`,
	"name": `Nhhb57aUMwkTOHZqrOIh`,
	"message": `fBioiwZ1VdoHytqqPnQh`,
	"cellWrapper": `gAMasWbIqEivzAoEhvy0`,
	"linkWrapper": `Thy9qDxrtncXjt4yYb_D`,
	"qr": `zWWW2FVECQ6mGLLwLN2Y`
};
export default ___CSS_LOADER_EXPORT___;
